<template>
  <div class="function-documentation-tab">
    <div class="text-h6 q-mb-md">Function Description</div>

    <q-card flat bordered>
      <q-card-section>
        <q-input
          :model-value="modelValue.purpose"
          label="Purpose / Primary Function"
          type="textarea"
          outlined
          rows="3"
          class="q-mb-md"
          placeholder="Describe the primary purpose and function of this AHU..."
          @update:model-value="emit('update:purpose', $event)"
        />

        <q-input
          :model-value="modelValue.operation_modes"
          label="Operation Modes"
          type="textarea"
          outlined
          rows="3"
          class="q-mb-md"
          placeholder="List operation modes (e.g., Heating, Cooling, Economizer, Night Purge)..."
          @update:model-value="emit('update:operation-modes', $event)"
        />

        <q-input
          :model-value="modelValue.control_strategy"
          label="Control Strategy"
          type="textarea"
          outlined
          rows="4"
          placeholder="Describe the control strategy, setpoints, and sequences..."
          @update:model-value="emit('update:control-strategy', $event)"
        />
      </q-card-section>
    </q-card>
  </div>
</template>

<script setup>
/**
 * Function Documentation Tab Component
 *
 * Displays form for documenting equipment function and operation
 */

  const props = defineProps({
    modelValue: {
      type: Object,
      required: true,
      default: () => ({
        purpose: '',
        operation_modes: '',
        control_strategy: '',
      }),
    },
  });

  const emit = defineEmits([
    'update:purpose',
    'update:operation-modes',
    'update:control-strategy',
  ]);
</script>

<style scoped>
.function-documentation-tab {
  height: 100%;
}
</style>
